import { SegmentPage } from '@enums/segment'
import { ignoreCypress } from '@util/ignore-cypress'
import { pageEvent } from './page'

type SegmentCustomPageEvent = {
  (pageMane: SegmentPage): void
}

const handleCustomPageEvent: SegmentCustomPageEvent = (pageName) => {
  pageEvent(pageName)
}

export const trackCustomPageEvent = ignoreCypress(handleCustomPageEvent)
